import {
    BACKGROUND_SYNC_STATUS,
    runBackgroundItemSync,
    useBackgroundItemSyncStore,
} from '@register-ui/utils';
import { useEffect, useMemo } from 'react';
import { type BannerVariant } from '../types';

export const SUCCESSFUL_SYNC_BANNER_DURATION = 3000;

export function useBackgroundItemsSyncIndicator() {
    const { syncStatus, setSyncStatus } = useBackgroundItemSyncStore();

    useEffect(() => {
        if (syncStatus !== BACKGROUND_SYNC_STATUS.Success) {
            return;
        }

        const timer = setTimeout(() => {
            setSyncStatus(BACKGROUND_SYNC_STATUS.Idle);
        }, SUCCESSFUL_SYNC_BANNER_DURATION);

        return () => clearTimeout(timer);
    }, [syncStatus, setSyncStatus]);

    const backgroundItemsVariant: BannerVariant = useMemo(() => {
        switch (syncStatus) {
            case BACKGROUND_SYNC_STATUS.Success: {
                return 'success';
            }
            case BACKGROUND_SYNC_STATUS.Failed: {
                return 'error';
            }
            default: {
                return 'info';
            }
        }
    }, [syncStatus]);

    const showBackgroundItemsBanner =
        syncStatus !== BACKGROUND_SYNC_STATUS.Idle;

    const retry = () => {
        runBackgroundItemSync();
    };

    return {
        backgroundItemsStatus: syncStatus,
        backgroundItemsVariant,
        showBackgroundItemsBanner,
        retry,
    };
}
